export default __webpack_public_path__ + "static/media/payment_activated_desktop.e34d2c55.svg";